import React from 'react';
import Playlist from '../Playlist';
import './selected-playlist-carousel.scss';

/////Import Buttons
import { LEFT, RIGHT, UP, DOWN, BACK, ENTER } from '../../util/remoteButtons';

export default class SelectedPlaylistCarousel extends React.Component {
  constructor(props) {
    super(props);
    const playlist = props.playlist ? props.playlist : [];
    const myPlaylist = props.myPlaylist ? props.myPlaylist.data : [];

    this.state = {
      current: props.currentPlaylist === 0 ? parseInt(playlist.length / 2) : props.currentPlaylist,
      show: false,
      playlists: playlist,
      featuredPlaylist: playlist,
      myPlaylist,
      playlistName: playlist.name,
      highquality: 'high',
      firstPlaylist: 0,
      collectionName: 'Featured Collections',
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.playlistTimeout = null;
  }

  componentDidMount() {
    this.setList();
    this.playlistTimeout = setTimeout(() => {
      this.props.onExitApp();
    }, 5000);
  }

  setList() {
    const { current, playlists } = this.state;
    if (current == playlists.length - 1 || current == playlists.length - 2) {
      const newArray = this.state.playlists.slice();
      for (let i = 0; i < playlists.length; i++) {
        newArray.push(playlists[i]);
        this.setState({
          playlists: newArray,
        });
      }
    }
  }

  handleKeyDown(e) {
    switch (e.which) {
      case ENTER: 
        clearTimeout(this.playlistTimeout);
        this.props.getArtworkFromPlaylist(this.state.playlists[this.state.current].playlistId);
        break;
      case UP:
        clearTimeout(this.playlistTimeout);
        if (this.state.collectionName === 'Your Collections')
          this.setState({
            collectionName: 'Featured Collections',
            playlists: this.state.featuredPlaylist,
            current: parseInt(this.state.featuredPlaylist.length / 2),
          });
        else this.props.hideCollections();
        break;
      case DOWN:
        clearTimeout(this.playlistTimeout);
        if (this.state.collectionName === 'Featured Collections')
          this.setState({
            collectionName: 'Your Collections',
            playlists: this.state.myPlaylist,
            current: parseInt(this.state.myPlaylist.length / 2),
          });
        break;
      case LEFT:
        clearTimeout(this.playlistTimeout);
        this.prev();
        this.playlistTimeout = setTimeout(() => {
          this.props.onExitApp();
        }, 5000);
        break;
      case RIGHT:
        clearTimeout(this.playlistTimeout);
        this.next();
        this.playlistTimeout = setTimeout(() => {
          this.props.onExitApp();
        }, 5000);
        break;
      case 27:
      case BACK:
        this.props.onExitApp();
        break;
    }
  }

  handleClick(count) {
    this.getArtworkFromPlaylist(count);
  }

  next() {
    const newArray = this.state.playlists.slice(0);
    newArray.push(newArray.shift());
    this.setState({
      playlists: newArray,
    });
    this.props.setCurrent(this.state.playlists[this.state.current + 1].playlistId);
  }

  prev() {
    const slides = this.state.playlists.slice(0);
    slides.unshift(slides.pop());
    this.setState({ playlists: slides });
    this.props.setCurrent(this.state.playlists[this.state.current - 1].playlistId);
  }

  render() {
    const { current } = this.state;
    const { playlists } = this.state || {};

    if (!playlists) {
      return null;
    }
    let left = -(current * 27) + 10;
    const slides = playlists.map((item, idx) => {
      left += 27;
      return (
        <div key={idx} className="selected-carousel__slide" style={{ left: `${left}%` }}>
          <Playlist key={idx} handleClick={this.handleClick} showDetails={idx == current} playlist={item} />
        </div>
      );
    });
    return (
      <div
        tabIndex="2"
        className="selected-carousel"
        ref="carousel"
        onKeyDown={this.handleKeyDown}
        onBlur={() => this.setState({ show: false })}
      > 
        <div className="selected-carousel__collection">
          <div className="selected-carousel__collection__arrows">
            <img className="selected-carousel__collection__arrows__arrow" src="assets/img/up.png" alt="" />
            <img className="selected-carousel__collection__arrows__arrow" src="assets/img/down.png" alt="" />
          </div>
          <p className="selected-carousel__collection__name">{this.state.collectionName}</p>
        </div>
        <div>{slides}</div>
      </div>
    );
  }
}
